import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    // Track pageview in Google Analytics for SPA navigation
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-L2FHCS9VVE', {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, [pathname]);

  return null;
}
